import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setModerationList } from "../../repository/slice";

function* getAttemptsForModerationWorker({ payload }: any): SagaIterator {
  const { id, ...rest } = payload;

  try {
    yield put(setLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      `/api/admin/quiz/get/${id}/attempts-for-moderation`,
      rest
    );

    if (isError) {
      console.error(message);
    } else {
      yield put(setModerationList(data));
    }
  } catch (error) {
    console.error("getAttemptsForModerationWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getAttemptsForModerationWatcher() {
  yield takeEvery(
    "@saga/GET_ATTEMPTS_FOR_MODERATION",
    getAttemptsForModerationWorker
  );
}
